import { timeline } from "../data";

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {/* sticky intro */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="text-primary-600 font-semibold tracking-wide text-sm">TIMELINE · 事件脉络</p>
              <h2 className="mt-2 font-heading text-3xl md:text-4xl font-extrabold text-foreground-950">
                搭讪实拍争议，如何一步步走到今天
              </h2>
              <p className="mt-3 text-foreground-600 leading-7">
                从同质化井喷到平台集中治理，街头搭讪内容经历了完整的\"热—争议—祛魅—规范\"周期。
                我们按阶段梳理，帮你看清每一次下架与讨论背后的推手。
              </p>
              <div className="mt-6 inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-700">
                <i className="ri-history-line text-primary-500"></i>
                周期观察 · 持续更新
              </div>
            </div>
          </div>

          {/* timeline */}
          <div className="lg:col-span-8">
            <ol className="relative border-l-2 border-background-200 pl-6 md:pl-8 space-y-6">
              {timeline.map((t, i) => (
                <li key={t.title} className="relative">
                  <span
                    className={`absolute -left-[31px] md:-left-[39px] top-1.5 w-5 h-5 rounded-full border-4 ${
                      i === timeline.length - 1
                        ? "bg-primary-500 border-primary-100"
                        : "bg-accent-500 border-background-100"
                    }`}
                  ></span>
                  <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-5">
                    <span className="shrink-0 inline-flex items-center px-2.5 py-1 rounded-md bg-accent-100 text-accent-800 text-xs font-semibold whitespace-nowrap">
                      {t.time}
                    </span>
                    <div className="p-5 rounded-2xl bg-background-50 border border-background-200 flex-1">
                      <h3 className="font-heading text-lg font-bold text-foreground-950">{t.title}</h3>
                      <p className="mt-1.5 text-sm leading-6 text-foreground-600">{t.desc}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}